export const SET_SHOW_ATTRIBUTES                   = "SET_SHOW_ATTRIBUTES"
export const SET_CANONICAL_NODES                   = "SET_CANONICAL_NODES"
export const SET_VIS_TO_WVR_MAP                    = "SET_VIS_TO_WVR_MAP"
export const SET_GRAPH_ADDING_EDGE                 = "SET_GRAPH_ADDING_EDGE"
export const SET_GRAPH_COLOR_PICKER_PROPS          = "SET_GRAPH_COLOR_PICKER_PROPS"
export const SET_GRAPH_CREATING_EDGE               = "SET_GRAPH_CREATING_EDGE"
export const SET_GRAPH_RENAME_RELATION_PROPS       = "SET_GRAPH_RENAME_RELATION_PROPS"
export const SET_GROUPS                            = "SET_GROUPS"
export const SET_SHOW_RELEVANT_META_NODES          = "SET_SHOW_RELEVANT_META_NODES"
export const SET_SHOW_ALL_META_NODES               = "SET_SHOW_ALL_META_NODES"
export const SET_QUERY_RESULTS                     = "SET_QUERY_RESULTS"
export const SET_RICH_NODE_MAP                     = "SET_RICH_NODE_MAP"
